module.exports = '4.9.0';



// WEBPACK FOOTER //
// ./src/version.js